import { useEffect } from 'react';
import { CustomLoginPopupWindowName, SignInTimeout } from 'AuthConstants';
import { authlog } from 'AuthLogger';
import { IAuthResultMessage } from 'AuthService.types';
import { pageDataService } from 'common/utilities';
import { isSafari } from 'common/utilities/BrowserHelpers';
import { localeIgnoreCaseEquals } from 'common/utilities/String';
import TelemetryProvider from 'common/utilities/TelemetryProvider';
import { useAppSelector } from 'store';

const useHandleAuthError = () => {
  const originUrl = useAppSelector((state) => state.auth.requestState.originUrl);
  const isAuthPending = localeIgnoreCaseEquals(window.location.pathname, '/signin-spa') && !originUrl;
  const isCustomLoginPopup = window?.name === CustomLoginPopupWindowName;
  const shouldStartTimer = isCustomLoginPopup && isAuthPending;

  // detect if the user is stuck on the signin-spa page
  useEffect(() => {
    let timeout: unknown;
    if (shouldStartTimer) {
      timeout = setTimeout(() => {
        if (isAuthPending) {
          TelemetryProvider.Instance.trackException(new Error('singin-spa page is stuck'), 'SignInSpa page error', {
            isSafari: isSafari(),
          });

          // user is stuck on the signin-spa page for more than 10 seconds
          const message: IAuthResultMessage = {
            success: false,
            error: SignInTimeout,
          };

          authlog(`posting an error message to the main window`);

          // post an error message to a main window
          window.opener?.postMessage(message, pageDataService.getConsumerSecurityPortalHost());
        }
      }, 10000); // 10 seconds
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout as number);
      }
    };
  }, [isAuthPending, shouldStartTimer]);
};

export default useHandleAuthError;
